import type { WShopRecomendedProductsTranslations } from "./pl";

export const en: WShopRecomendedProductsTranslations = {
  title: "Recommended products",
  showAll: "See all",
  noProducts: "No recommended products.",
};
